import { makeRequestAction } from './index';

export const getDashboardCompanies = makeRequestAction('GET_DASHBOARD_COMPANIES', {
  onSuccess(params, response) {
    return {
      response: {
        ...response,
      },
    };
  },
});
